module.exports = __webpack_public_path__ + "static/pezinho-ed5bccee943ed419b603367061e98ba5.png";